module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sx-78b1d646fcfed5a2a74047838b5b8584.svg";